<div [class.component-main]="!embedded" [hidden]="embeddedPageOpen" [class.embedded]="embedded">
    <div class="content-space-between">
        <h1>{{ 'region' | myLbTranslate }} - {{ regionName }}</h1>
        <button
            id="region-add-subnet"
            class="primary"
            [disabled]="!permissionsLookup['region-edit-subnet']"
            (click)="addEditSubnet()">{{ 'subnet_add' | myLbTranslate }}
        </button>
    </div>

    <app-table
        id="region-details"
        [data]="tableRows"
        [stickyHeader]="true"
        [componentEmbedded]="embedded">
        <app-column [flexGrow]="0.5" prop="subnet" label="subnet"></app-column>
        <app-column
            prop="actions"
            label=""
            [cellTemplate]="actionsTemplate">
            <ng-template let-data let-index="index" #actionsTemplate>
                <div>
                    <app-action-dots>
                        <button
                            id="region-edit-subnet"
                            [disabled]="!permissionsLookup['region-edit-subnet']"
                            (click)="addEditSubnet(data)">
                            {{ 'edit' | myLbTranslate }}
                        </button>
                        <button
                            id="region-delete-subnet"
                            [disabled]="!permissionsLookup['region-delete-subnet']"
                            (click)="confirmDeleteSubnet(data, index)">
                            {{ 'delete' | myLbTranslate }}
                        </button>
                    </app-action-dots>
                </div>
            </ng-template>
        </app-column>
    </app-table>
</div>
<div class="component-footer" [class.embedded]="embedded">
    <button
        id="region-details-cancel"
        class="outline"
        (click)="goBack()">
        {{ 'cancel' | myLbTranslate }}
    </button>
</div>

<ng-container #embeddedComponentContainer></ng-container>
